"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports,"__esModule",{value:!0}),exports.Separator=exports.PlaceholderLabel=exports.LimitExceededInfo=exports.History=exports.CashBanner=exports.CashBalance=void 0;var _styledComponents=_interopRequireDefault(require("styled-components")),_global=require("../../../constants/global.constants");const CashBanner=exports.CashBanner=_styledComponents.default.div`
border:1px solid #fff;
border-radius: 8px 8px 0px 0px;

display: flex;
padding: 16px 16px 10px 16px;
/* align-items: center; */
background-color: #F1F0EE;
flex-direction: column;


gap: 10px;
align-self: stretch;


#scroll-content{
  max-height:400px;
overflow-y:auto;
scroll-behavior: smooth;
}

.bannerRow{
    margin-bottom: 5px;
}
.banner{
    display: flex;
    /* align-items: flex-end; */
    align-items: center;
    flex: 1 0 0; 
}
.bannerCashLogo{
    mix-blend-mode: darken;
    width: 24px;
    height: 24px;
}
.banner > div {
    display: flex;
align-items: center;
flex: 1 0 0;
}
h2{
font-size: 16px !important;
font-style: normal;
font-weight: 600 !important;   
color: #2A292B;
margin-top: unset;
margin-bottom: unset;
margin-left:5px;
}


.PendingInfoIcon{
    margin-left: 5px;
    mix-blend-mode: darken;
    width: 16px;
    height: 16px;
    padding: 2px;
}

.pendingBalance{
    display: flex;
    flex-direction: column;
    align-items: flex-end !important;
    width:100%;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; 
    color: #2A292B;
}

.pendingHeader{
    font-size: 14px !important;
}

.divider{
    margin-top: 0px;
    margin-bottom: 0px;
    width: 100%;
}
`,LimitExceededInfo=exports.LimitExceededInfo=_styledComponents.default.div`
div{
z-index: 10;
display: flex;
gap: 8px;
color: #2A2928;
align-items: center;
font-weight: 400;
font-size: 12px;
line-height: 18px;
}

img {
height:15.5px;
width: 15.5px
}
`,CashBalance=exports.CashBalance=_styledComponents.default.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    width:100%;


div{
    font-size: 20px;
font-style: normal;
font-weight: 600;
line-height: 24px; 
    color: #2A292B;
}
span{
    font-size: 10px;
font-style: normal;
font-weight: 400;
line-height: 16px;
    color: rgb(83, 82, 80);
}
`,Separator=exports.Separator=_styledComponents.default.hr`
    margin-top: 0px;
    margin-bottom: 0px;
    width: 96%;
`,History=exports.History=_styledComponents.default.div`
display: flex;
padding: 2px 16px 2px 16px;
align-items: center;
gap: 10px;
align-self: stretch;
background-color: #FFFFFF;

.inline{
    display: flex;
}

.activity{
  font-weight:600;
}


div{
    display: flex;
    justify-content: space-between;
align-items: center;
gap: 4px;
flex: 1 0 0;
color:#2A2928;
}

p{
    margin-top: 10px;
    margin-bottom: 6px;
}


`,PlaceholderLabel=exports.PlaceholderLabel=_styledComponents.default.div`
border:1px solid #fff
display: flex;
padding: 10px 16px;
align-items: center;
gap: 10px;
align-self: stretch;
border-radius: 0px 0px 8px 8px;
background-color: #FFFFFF;



p{
    font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 18px;
color:#535250;
margin-bottom: 0px;
}

.learnMore{
    font-weight:600;
    color: ${_global.Themes[_global.Banner]};
    text-decoration: underline;
}

`;